import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {clientsContractsStore} from '@store/clients/contracts/clients-contracts.store';
import {getClientsContractsDataSource} from '@store/clients/contracts/clients-contracts.requests';

export class ClientsContractsQuery {
  store = clientsContractsStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  clientsContracts$ = getClientsContractsDataSource.data$();
  selectedClientsContracts$ = this.store.pipe(
    selectManyByPredicate((clientsContractUI) => clientsContractUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const clientsContractsQuery = new ClientsContractsQuery();